<template>
  <div class="page">
    <div class="comView">
      <div class="comp">
        <div>热销商品</div>
      </div>
      <div class="panel">
        <div class="nucleuscon">
          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">一级分类数</div>
              <div class="data">
                <div class="cell1">{{ goodsType.firstCategoryCount }}
                </div>
              </div>
            </div>
          </div>
          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">二级分类数</div>
              <div class="data">
                <div class="cell1">{{ goodsType.sendCategoryCount }}
                </div>

              </div>
            </div>
          </div>
          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">品牌数</div>
              <div class="data">
                <div class="cell1">{{ salelist.saleBrandCount }}
                </div>

              </div>
            </div>
          </div>

          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">正销售品种数</div>
              <div class="data">
                <div class="cell1">{{ salelist.saleGoodsTotalCount }}
                </div>

              </div>
            </div>
          </div>
          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">有库存品种数</div>
              <div class="data">
                <div class="cell1">{{ salelist.saleGoodsTotalCount_Stock }}
                </div>

              </div>
            </div>
          </div>
          <div class="nucleusitem">
            <div class="content">
              <div class="currentit">无库存品种数</div>
              <div class="data">
                <div class="cell1">{{ salelist.saleGoodsTotalCount_NoStock }}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input style="width: 130px; margin-right: 10px" placeholder="请输入关键字" v-model="search.key"
                @keyup.enter.native="clickSearch" clearable></el-input>
              <el-button @click="clickSearch" icon="el-icon-search" type="warning">搜索</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item>
              <el-select style="width: 120px" v-model="search.shopId" @change="changeShop">
                <el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="适用宠物">
              <el-select style="width: 120px" v-model="search.applyType" @change="changeShop">
                <el-option v-for="item in [
                  { label: '全部', value: -1 },
                  { label: '通用', value: 0 },
                  { label: '猫', value: 1 }, { label: '狗', value: 2 },
                ]" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="分类">
              <el-cascader ref="chooseRegionDom" v-model="arry" :options="classOptions"
                :props="{ label: 'label', value: 'id', children: 'children', multiple: true, expandTrigger: 'hover' }"
                :emitPath="true" collapse-tags clearable @change="changeSearch"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择日期范围">
              <el-date-picker @change="changeDate" style="width: 240px" v-model="datetimerange" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-table :data="props.row.skuDataList" style="width: 100%">
                <el-table-column label="规格" prop="skuName" width="500px">
                </el-table-column>
                <el-table-column label="销售额" prop="saleMoney" min-width="120">
                </el-table-column>
                <el-table-column label="销售量" prop="saleCount" min-width="120">
                </el-table-column>
                <el-table-column label="售卖天数" prop="saleDays" min-width="120">
                </el-table-column>
                <el-table-column label="成本价" prop="costPrice" min-width="120">
                </el-table-column>
                <el-table-column label="折扣率" prop="rate" min-width="120">
                  <template slot-scope="props">
                    <div>
                      {{ (props.row.rate * 100.0).toFixed(2) }}%
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="goodsName" min-width="120">
        </el-table-column>
        <el-table-column label="适用宠物" prop="applyType" min-width="120">
          <template slot-scope="props">
            <div>
              {{ props.row.applyType }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分类" prop="categoryName" min-width="120">

        </el-table-column>
        <el-table-column label="品牌" min-width="150" prop="brand">
        </el-table-column>
        <el-table-column label="销售额" prop="saleMoney" min-width="150">
          <template slot-scope="props">
            <div>
              {{ props.row.saleMoney.toFixed(2) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="销售量" prop="saleCount" min-width="150">

        </el-table-column>
        <el-table-column label="售卖天数" prop="saleDays" min-width="120">
        </el-table-column>
        <el-table-column label="折扣率" prop="rate" min-width="120">
          <template slot-scope="props">
            <div>
              {{ (props.row.rate * 100.0).toFixed(2) }}%
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import resetBtn from "../../../components/resetBtn.vue";
import shopsList from "../../../util/shopsList.js";
import {
  getProductTypeList, // api.get(`${baseURL2}api/dict/ProductType/tree`
} from "../../../api/productApi.js";
export default {
  components: { resetBtn },
  data() {
    return {
      search: {
        shopId: "",
        applyType: 0,
        isShopUse: true,
        begin: '',
        end: "",
        key: "",
        categorize: [],  //线上分类
      },
      arry: [],
      props: { multiple: true },
      shopsList: shopsList,
      datetimerange: [],
      classOptions: [],
      tableData: [],
      salelist: null,
      goodsType: null


    };
  },
  watch: {},
  computed: {},
  mounted() {
    let monthName = moment().format("M");
    let time = new Date();
    let startTime = moment(time).month(monthName - 1).date(1).startOf("monthName").format("YYYY-MM-DD");
    this.datetimerange[0] = startTime
    this.datetimerange[1] = moment().format("YYYY-MM-DD")
    this.getSale()
    this.getType()
    this.getClassData()

    this.getTableData();
  },
  methods: {
    reset() {
      this.search = {
        shopId: "",
        applyType: 0,
        key: "",
        categorize: []
      };
      this.arry = []
      this.datetimerange = [];
      this.getTableData();
    },

    clickSearch() {

      this.getTableData();
    },
    changeShop(){
      this.getTableData();
    },
    changeSearch(val) {
      console.log(val, 'val.length');
      if (val.length == 0) {
        this.search.categorize = []
      } else {
        let arry = []
        val.map((item) => {
          console.log(item[1], 'item');
          arry.push(item[1])
        })
        this.search.categorize = arry
      }

      this.getTableData();
    },
    changeDate() {
      this.getTableData();
    },
    // 改变分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    //获取商品品种
    getSale() {
      this.$http.get(process.env.VUE_APP_Url2 + 'api/product/goods/sale/category/statistics').then((res) => {
        if (res.code == 0) {
          this.salelist = res.data
        }
      })
    },
    // 获取商品分类
    getType() {
      this.$http.get(process.env.VUE_APP_Url2 + 'api/dict/goods/category/statistics').then((res) => {
        if (res.code == 0) {
          this.goodsType = res.data
        }
      })
    },
    //获取类别
    getClassData() {
      getProductTypeList({
        category: "商品",
      }).then((res) => {
        if (res.code == 0) {
          console.log(res.data,"商品");
          this.classOptions = res.data[0].children;
        }
      });
    },
    getTableData() {
      let params = {
        shopId: this.search.shopId,
        applyType: this.search.applyType,
        isShopUse: this.search.isShopUse,
        key: this.search.key,
        categorize: this.search.categorize,
      };
      if (this.datetimerange && this.datetimerange.length == 2) {
        params.begin = this.datetimerange[0]
        params.end = this.datetimerange[1]
      }
      let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_zichan + "/api/bi/GoodsStatic", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log(res, "res");
          this.tableData = res.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .pageConBox {
    min-height: 600px;
  }

  .comView {
    background-color: #fff;
    margin-bottom: 10px;
  }

  .comp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 10px;
  }

  .comp>div:nth-child(1) {
    font-size: 25px;
    font-weight: 700;
  }

  .panel {
    box-sizing: border-box;
    width: 100%;
    margin-right: 20px;
    line-height: 30px;
  }

  .panelitem {}


  .nucleuscon {
    margin-top: 10px;
    display: flex;

    .nucleusitem {
      border-right: 1px solid #ddd;
      width: 20%;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      margin: auto;
      margin-top: 20px;

      &:last-child {
        border: none;
      }

      .content {
        max-width: 180px;
        margin: auto;
      }

      .currentit {
        color: #666666;
        font-size: 14px;
      }

      .data {
        margin: 10px 0;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }

      .compare {
        color: #666666;
        font-size: 12px;
      }
    }
  }
}
</style>
  